import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import useDataContext from "../providers/DataProvider/useDataContext";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Whatsapp from "../components/Whatsapp/Whatsapp";
import InstagramButton from "../components/InstagramButton/InstagramButton";
import OutsidePagination from "../components/OutsidePagination/OutsidePagination";
import OutsideFullCard from "../components/OutsideFullCard/OutsideFullCard";
import Spinner from "../components/Spinner/Spinner";

/* ========================================================================== */

interface LocationState {
    outsideIndex: number
}

const OutsidePage: React.FC = () =>  {
    const { data } = useDataContext();
    const location = useLocation();
    const locationState = location.state as LocationState | undefined;
    const [outsideIndex, setOutsideIndex] = useState<number>(locationState?.outsideIndex ?? 0);
    const [outsideInfo, setOutsideInfo] = useState(() => {
        const foundOutside = data.outside.find(out => out.index === outsideIndex);
        return foundOutside ? foundOutside : data.outside[0]
    });
    const outsideNames = data.outside.map(out => out.name);

    const [isLoading, setIsLoading] = useState(true);


    useEffect (() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsLoading(true);
        setOutsideInfo(() => {
            const foundOutside = data.outside.find(out => out.index === outsideIndex);
            return foundOutside ? foundOutside : data.outside[0]
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outsideIndex])

    const allImagesLoaded = () => {
        setTimeout(() => setIsLoading(false), 1000);
    }

    return (
    <>
        <Header isHomePage={false}/>

        <main className="bg-forth-solid px-4">
            <OutsidePagination outsideIndex={outsideIndex}
                               outsideNames={outsideNames}
                               setOutsideIndex={setOutsideIndex}/>

            { isLoading && <Spinner color="bg-first-solid" pxSize={20}/> }
            
            <OutsideFullCard outsideImages={outsideInfo.images.outsideImages}
                             onAllImagesLoaded={allImagesLoaded}
                             isHidden={isLoading}/>

        </main>

        <InstagramButton isHomePage={false}/>

        <Whatsapp isHomePage={false}/>

        <Footer isHomePage={false}/>
    </>
    )
}

export default OutsidePage;
